import styles from "../Startup/Choose.module.css";
import { Logo, ToastContainer, BiCheck, AiOutlineLoading3Quarters, useState, useParams } from '../../common/common'
import MidProductAttributes from "../../middleware/Seller/Details/MidProductAttributes";
import { useErrorContext } from '../../context/ErrorContext';
import useNavigation from '../../common/useNavigation';
import Sidebar from '../Components/Sidebar';
import Topbar from '../Components/Topbar';
import MidEditProductAttributes from "../../middleware/Seller/Details/MidEditProductAttributes";
const EditProductAttributes = () => {
    const { type } = useParams();
    const [issidebarOpen, setIssidebarOpen] = useState(true);
    const { error } = useErrorContext();
    const handlesetIssidebarOpen = () => setIssidebarOpen(!issidebarOpen);
    const { users, userPlan, Remainuser, subUser, getattributes, isloggedin, isDisabled, handleSubmit, checkedIds, setCheckedIds, userProductAttributes } = MidEditProductAttributes();

    const { navigateGeneralSetting } = useNavigation();
    if (Array.isArray(users) && users.length > 0) {
        var AppID = users[0]['AppID'];
        var ProfilePic = users[0]['ProfilePic'];
        var usertype = users[0]['UserType'];
        var username = users[0]['FullName'];
        var CompanyName = users[0]['CompanyName'];
        var userAddress1 = users[0]['Address1'];
        var userAddress2 = users[0]['Address2'];
        var Mobile = users[0]['Mobile'];
        var RegistrationDate = users[0]['RegistrationDate'];
        var EmailAddress = users[0]['EmailAddress'];
        var ActiveUser = users[0]["Status"]
    }
    if (Array.isArray(userPlan) && userPlan.length > 0) {
        var planID = userPlan[0]['plan_id'];
    }
    const handleCheckboxChange = (id) => {
        setCheckedIds((prevCheckedIds) => {
            if (prevCheckedIds.includes(id)) {
                return prevCheckedIds.filter((checkboxId) => checkboxId !== id);
            } else {
                return [...prevCheckedIds, id];
            }
        });
    };

    // console.log({checkedIds:checkedIds});
    const ProductCategoryItem = ({ id, title, description, isChecked, onChange }) => {
        return (
            <div className="flex flex-col lg:flex-row border-2 border-solid border-[#e5e5e5] p-3 rounded-md">
                <label className="relative inline-flex items-center cursor-pointer">
                    <input type="checkbox" checked={isChecked} onChange={() => onChange(id)} className="sr-only" />
                    <span className={`w-6 h-6 inline-block rounded-full border-2 transition-all 
                  ${isChecked ? 'bg-green-500 border-green-500' : 'bg-white border-gray-400'}
                  flex items-center justify-center relative`}>
                        {isChecked && (<svg className="absolute top-0 left-0 w-full h-full text-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" > <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" /></svg>)} </span>
                </label>
                <label htmlFor="product3" className="flex flex-col lg:flex-row w-full">
                    <h5 className="text-md font-semibold text-[#615c59] px-3 py-2 w-[100%] lg:w-[60%] lg:ml-[10%]">{title}</h5>
                </label>
                <p className="pl-3 text-[#0cb1a3] text-md font-medium  w-[100%]">{description}</p>
            </div>
        );
    };
    return (
        <div className="md:flex md:flex-row md:w-full">
            <div className={`${issidebarOpen ? 'w-0  md:w-1/5' : 'w-0'}`}>
                <Sidebar handleSideBar={handlesetIssidebarOpen} issidebarOpen={issidebarOpen} UserTypeData={usertype} userName={username} appID={AppID} profilePic={ProfilePic} currentUserType={type} currentplan={planID} />
            </div>
            <div className={`${issidebarOpen ? 'w-full md:ml-2 md:w-[80%]' : 'ml-20 w-full'} `} >
                <Topbar issidebarOpen={issidebarOpen} UserTypeData={usertype} currentUserType={type} />
                <div className="w-full ">
                    <div className="col-start-1 col-end-13">
                        <div className=" p-2 text-xl text-[#1e3a8a]">
                            <div className='px-3'>
                                <h1 className=' text-lg text-theme-color-text font-bold'> Product Categories</h1>
                                <p className=' text-gray-600 text-[16px] '>A product category is a group of similar type of products. Ex. Menswear,Womenswear,Childrenswear</p>
                            </div>
                        </div>
                    </div>


                    <div className="max-w-full bg-white pb-10 mb-24 px-3">
                        <div className=" p-3 rounded-xl my-2 bg-[#ddfdfa]">
                            <div>
                                <h1 className="text-lg text-[#0cb1a3] font-bold"> Product Attributes </h1>
                                <p className="text-[#414747] text-sm font-medium"> Please select the appropriate attributes corresponding to your product range. The product code, name, and category are mandatory fields. You have the option to include all relevant attributes when adding product data, while selectively displaying only a subset of these attributes to your customers.</p>
                            </div>
                        </div>

                        <div className="border-[1px] border-solid border-[#dcdcdc] rounded-xl lg:p-5">
                            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-1 gap-6">
                                <div className="px-3">
                                    <h1 className=" text-lg font-bold text-[#2b2b2b]"> Mandatory Fields <span className=" text-red-600 text-xl">*</span> </h1>
                                </div>
                                <div className="flex flex-col lg:flex-row border-2 border-solid border-[#e5e5e5] p-3 rounded-md">
                                    <label className="relative inline-flex items-center cursor-pointer">
                                        <input type="checkbox" defaultChecked={true} className="sr-only" />
                                        <span className="w-6 h-6 rounded-full border-2 transition-all bg-green-500 border-green-500  flex items-center justify-center relative">
                                            <svg className="absolute top-0 left-0 w-full h-full text-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill=" none" stroke=" currentColor" strokeWidth="2"> <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" /></svg>
                                        </span>
                                    </label>

                                    {/* <input className="w-8 h-8 accent-green-300  focus:ring-green-500 rounded-full" type="checkbox" name="product_code" id="product_code" defaultChecked={true} ></input> */}
                                    <label htmlFor="product_code" className="flex flex-col lg:flex-row w-full">
                                        <h5 className="text-md font-semibold text-[#615c59] lg:px-3 py-2 w-[100%] lg:w-[60%] lg:ml-[10%]"> Product Code / Product SKU <br /> (NUMERIC IDENTIFIACTION CODE ) </h5>
                                    </label>
                                    <p className="lg:pl-3 text-[#0cb1a3] text-md font-medium  w-[100%]"> {" "} A product code is a unique identifier used for inventory management, such as "TS001-BLU-L" for a large blue t-shirt. </p>
                                </div>
                                <div className="flex flex-col lg:flex-row border-2 border-solid border-[#e5e5e5] p-3 rounded-md">
                                    {/* <input type="checkbox" name="product_name" id="product_name" defaultChecked={true} ></input> */}
                                    <label className="relative inline-flex items-center cursor-pointer">
                                        <input type="checkbox" defaultChecked={true} className="sr-only" />
                                        <span className="w-6 h-6 rounded-full border-2 transition-all bg-green-500 border-green-500  flex items-center justify-center relative">
                                            <svg className="absolute top-0 left-0 w-full h-full text-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill=" none" stroke=" currentColor" strokeWidth="2"> <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" /></svg>
                                        </span>
                                    </label>
                                    <label htmlFor="product2" className="flex flex-col lg:flex-row w-full" >
                                        <h5 className="text-md font-semibold text-[#615c59] px-3 py-2 w-[100%] lg:w-[60%] lg:ml-[10%]"> Product Name{" "} </h5>
                                    </label>
                                    <p className="pl-3 text-[#0cb1a3] text-md font-medium  w-[100%]"> {" "} A product name is the distinctive title given to a specific item, like "iPhone 13 Pro Max" for Apple's latest smartphone model. </p>
                                </div>
                                <div className="flex flex-col lg:flex-row border-2 border-solid border-[#e5e5e5] p-3 rounded-md">
                                    <label className="relative inline-flex items-center cursor-pointer">
                                        <input type="checkbox" defaultChecked={true} className="sr-only" />
                                        <span className="w-6 h-6 rounded-full border-2 transition-all bg-green-500 border-green-500  flex items-center justify-center relative">
                                            <svg className="absolute top-0 left-0 w-full h-full text-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill=" none" stroke=" currentColor" strokeWidth="2"> <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" /></svg>
                                        </span>
                                    </label>
                                    <label htmlFor="product3" className="flex flex-col lg:flex-row w-full">
                                        <h5 className="text-md font-semibold text-[#615c59] px-3 py-2 w-[100%] lg:w-[60%] lg:ml-[10%]"> Product Main Category{" "} </h5>
                                    </label>
                                    <p className="pl-3 text-[#0cb1a3] text-md font-medium  w-[100%]"> {" "} A product category is a classification that groups similar items together, such as "Electronics"  </p>
                                </div>
                            </div>
                            <form>
                                <div className="p-0">
                                    <div className="px-3 ">
                                        <h1 className=" text-md font-semibold text-[#0cb1a3] py-3 "> {" "} Choose Product Category{" "}
                                            <span className="text-sm"> (Import data for these attributes from Microsoft excel) </span>{" "}
                                            <span className=" text-red-600 text-xl">*</span>
                                        </h1>{" "}
                                    </div>
                                    <div className="mx-auto">
                                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-1 gap-6">
                                            {getattributes.map((category, index) => (
                                                <ProductCategoryItem
                                                    key={category.id}
                                                    id={category.id}
                                                    title={category?.attribute_name?.replace(/_/g, " ") || "No Title"} // Fallback if attribute_name is undefined
                                                    description={category?.atributes_description || category.id} // Fallback if description is undefined
                                                    isChecked={checkedIds.includes(category.id)}
                                                    onChange={handleCheckboxChange}
                                                />
                                            ))}
                                        </div>
                                    </div>

                                    {ActiveUser === 1 &&
                                        <div className="my-12 flex justify-end">
                                            <button
                                                className={`relative group px-12 h-14 text-center rounded-full flex flex-row items-center ${isDisabled ? 'cursor-not-allowed opacity-80 bg-button-color' : 'bg-[#0bb29f] hover:bg-[#0bb29f]'
                                                    }`}
                                                onClick={isDisabled ? undefined : handleSubmit}
                                                disabled={isDisabled}
                                            >
                                                {isloggedin ? (
                                                    <span className={`flex flex-row text-md font-semibold ${isDisabled ? 'text-black' : 'text-white'}`}>
                                                        <AiOutlineLoading3Quarters className="animate-spin h-5 w-5 mr-3" />
                                                        Processing
                                                    </span>
                                                ) : (
                                                    <span className={`relative text-md text-center font-semibold ${isDisabled ? 'text-black' : 'text-white'}`}>
                                                        {isDisabled ? 'Submit' : 'Update'}
                                                    </span>
                                                )}
                                                <div className={`flex items-center h-12 w-12 rounded-3xl ${isDisabled ? 'bg-button-color' : 'bg-[#0bb29f] hover:bg-[#0bb29f]'} absolute right-0 z-20`}>
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        className={`h-6 w-6 stroke-${isDisabled ? 'black' : 'white'} translate-x-3 transition duration-300 ${!isDisabled && 'group-hover:translate-x-5'}`}
                                                        fill="none"
                                                        viewBox="0 0 24 24"
                                                        stroke="currentColor"
                                                        strokeWidth="2"
                                                    >
                                                        <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                                                    </svg>
                                                </div>
                                            </button>
                                        </div>
                                    }

                                </div>
                                <ToastContainer />
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default EditProductAttributes